/* Working-hours options and the string the API stores. */

export const DAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

/* 30-minute increments, 6:00 AM to 11:30 PM, as the design specifies. */
export const timeOptions = () => {
  const out = [];
  for (let h = 6; h < 24; h += 1) {
    ["00", "30"].forEach((m) => {
      const period = h < 12 ? "AM" : "PM";
      const hh = h === 12 ? 12 : h > 12 ? h - 12 : h;
      out.push(`${String(hh).padStart(2, "0")}:${m} ${period}`);
    });
  }
  return out;
};

export const DEFAULT_WORKING_HOURS = {
  fromDay: "Monday",
  toDay: "Friday",
  open: "09:00 AM",
  close: "06:00 PM",
};

/* "09:00 AM" -> "9AM", "08:30 PM" -> "8:30PM" — the compact form the existing
   default string uses. A whole hour drops its ":00". */
const compactTime = (t) => {
  const match = /^(\d{1,2}):(\d{2})\s*(AM|PM)$/i.exec(String(t || "").trim());
  if (!match) return String(t || "");
  const [, h, m, period] = match;
  const hour = String(Number(h));
  return m === "00"
    ? `${hour}${period.toUpperCase()}`
    : `${hour}:${m}${period.toUpperCase()}`;
};

/* Composes the four selects back into the sentence `working_hours` holds:
   "Monday to Friday 9AM to 6PM". */
export const formatWorkingHours = ({ fromDay, toDay, open, close } = {}) => {
  const from = fromDay || DEFAULT_WORKING_HOURS.fromDay;
  const to = toDay || DEFAULT_WORKING_HOURS.toDay;
  const o = compactTime(open || DEFAULT_WORKING_HOURS.open);
  const c = compactTime(close || DEFAULT_WORKING_HOURS.close);
  return `${from} to ${to} ${o} to ${c}`;
};

/* The inverse, for an address coming back from the API. Anything that does not
   match falls back to the default rather than throwing — a profile saved
   before this screen existed may hold any string at all. */
export const parseWorkingHours = (value) => {
  const match = /^(\w+)\s+to\s+(\w+)\s+(.+?)\s+to\s+(.+)$/i.exec(String(value || "").trim());
  if (!match) return { ...DEFAULT_WORKING_HOURS };

  const [, fromDay, toDay, open, close] = match;
  const day = (d) => DAYS.find((x) => x.toLowerCase() === d.toLowerCase());
  const expand = (t) => {
    const m = /^(\d{1,2})(?::(\d{2}))?\s*(AM|PM)$/i.exec(t.trim());
    if (!m) return null;
    return `${String(Number(m[1])).padStart(2, "0")}:${m[2] || "00"} ${m[3].toUpperCase()}`;
  };

  return {
    fromDay: day(fromDay) || DEFAULT_WORKING_HOURS.fromDay,
    toDay: day(toDay) || DEFAULT_WORKING_HOURS.toDay,
    open: expand(open) || DEFAULT_WORKING_HOURS.open,
    close: expand(close) || DEFAULT_WORKING_HOURS.close,
  };
};
